<script setup lang="ts">
withDefaults(
  defineProps<{
    innerClasses?: string | Record<string, boolean>
    tag?: string
    padded?: boolean
  }>(),
  {
    tag: `section`,
    padded: true,
  },
);

defineSlots<{
  default: () => unknown
}>();
</script>

<template>
  <component
    :is="tag"
    class="md:px-m lg:px-none"
    :class="{
      'px-m': padded,
    }"
  >
    <div
      class="max-w-screen-xl mx-auto"
      :class="innerClasses"
    >
      <slot />
    </div>
  </component>
</template>
